const toVersion = (data) => ({
  id: data.version,
  title: data.title,
  content: data.content,
  editor: data.editor,
  updatedAt: data.updatedAt,
});

export default toVersion;
